<template>
    <div class="my-2 pt-2 pb-3 flex justify-between items-center border-b">
        <div class="flex">
            <p class="flex items-center text-sm text-gray-500">
                <span
                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                    :class="apartment.style"
                >
                    {{ $t("states." + apartment.state) }}
                </span>
            </p>
            <p class="flex items-center text-sm text-gray-500 ml-6">
                <ClipboardListIcon class="mr-2 h-5 w-5 text-minplan-darkgreybeige" />
                <span class="hidden md:flex ml-1">
                    {{ topics.completed }} / {{ topics.total }}
                    {{ $t("apartments.finishedTopics") }}</span
                >
            </p>
            <!-- <p class="flex items-center text-sm text-gray-500 ml-6">
                <ExclamationIcon class="mr-2 h-5 w-5 text-red-700" />
                {{ deadlinesMissed }}
                <span class="hidden md:flex ml-1">{{ $t("projects.deadline") }}</span>
            </p> -->
        </div>

        <div class="flex">
            <button
                @click="onDelete"
                v-if="manageTopicsRoute"
                :disabled="!deletable"
                class="group flex items-center text-sm text-gray-500 mr-6 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <TrashIcon class="mr-1 h-5 w-5 text-gray-500 group-hover:text-red-700" />
                <span class="hidden md:flex ml-1">
                    {{ $t("actions.delete") }}
                </span>
            </button>
            <button
                type="button"
                class="flex items-center text-sm text-gray-500"
                v-if="editStateRoute"
                @click="
                    $inertia.visitInModal(
                        route(editStateRoute, { apartment: apartment.uuid })
                    )
                "
            >
                <TagIcon class="mr-1 h-5 w-5 text-minplan-darkgreybeige" />
                <span class="hidden md:flex ml-1">
                    {{ $t("projects.stateChange") }}
                </span>
            </button>

            <Link
                :href="route(manageTopicsRoute, { apartment: apartment.uuid })"
                v-if="manageTopicsRoute"
                class="flex items-center text-sm text-gray-500 ml-6"
            >
                <CogIcon class="mr-1 h-5 w-5 text-minplan-darkgreybeige" />
                <span class="hidden md:flex ml-1">
                    {{ $t("projects.settings") }}
                </span>
            </Link>
        </div>
    </div>
</template>

<script>
import {
    ClipboardListIcon,
    ExclamationIcon,
    TrashIcon,
    TagIcon,
    CogIcon,
} from "@heroicons/vue/outline";
import { Link } from "@inertiajs/inertia-vue3";

export default {
    props: [
        "apartment",
        "topics",
        "editStateRoute",
        "manageTopicsRoute",
        "deletable",
        "deadlinesMissed",
        "onDelete",
    ],
    components: {
        TagIcon,
        ClipboardListIcon,
        ExclamationIcon,
        TrashIcon,
        CogIcon,
        Link,
    },
};
</script>

<style scoped></style>
